export default __webpack_public_path__ + "static/media/Headdress of the Crawling Chaos.4c3e5fcd.jpg";